export default "__VITE_ASSET__B$lisCli__"